import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import { useCart } from '../context/CartContext';
import './CustomerNav.css';

const CustomerNav = () => {
  const { user, isAdmin } = useAuth();
  const { t, isRTL } = useLanguage();
  const { items } = useCart();
  const location = useLocation();

  // Hide on admin pages
  if (!user || location.pathname.startsWith('/dashboard4')) return null;

  const cartItemCount = items.reduce((sum, item) => sum + item.quantity, 0);

  const navItems = [
    { path: '/profile', label: t('profile') || 'Profile', icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg> },
    { path: '/orders', label: t('myOrders') || 'Orders', icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="16.5" y1="9.4" x2="7.5" y2="4.21"/><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 002 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/></svg> },
    ...(isAdmin ? [{ path: '/dashboard4', label: isRTL ? 'الإدارة' : 'Admin', icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 01-2.83 2.83l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/></svg> }] : []),
  ];

  return (
    <div className={`customer-nav ${isRTL ? 'rtl' : ''}`} dir={isRTL ? 'rtl' : 'ltr'}>
      <div className="container">
        <div className="customer-nav-content">
          <div className="customer-info">
            <span className="customer-greeting">{t('hello') || 'Hello'}, {user.name}</span>
          </div>
          <nav className="customer-links">
            {navItems.map(item => (
              <Link
                key={item.path}
                to={item.path}
                className={`customer-link ${location.pathname === item.path ? 'active' : ''}`}
              >
                <span className="link-icon">{item.icon}</span>
                {item.label}
              </Link>
            ))}
            {cartItemCount > 0 && (
              <>
                <Link
                  to="/cart"
                  className={`customer-link cart-link-nav ${location.pathname === '/cart' ? 'active' : ''}`}
                >
                  <span className="link-icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></svg></span>
                  {t('cart') || 'Cart'} ({cartItemCount})
                </Link>
                <Link
                  to="/checkout"
                  className="customer-link checkout-link-nav"
                >
                  {t('checkout') || 'Checkout'}
                </Link>
              </>
            )}
          </nav>
        </div>
      </div>
    </div>
  );
};

export default CustomerNav;
